var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClass = function SvgClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "3 3 26 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 5C5.355 5 4 6.355 4 8v16c0 1.645 1.355 3 3 3h18c1.645 0 3-1.355 3-3V8c0-1.645-1.355-3-3-3Zm0 2h18c.566 0 1 .434 1 1v16c0 .566-.434 1-1 1h-2v-2h-5v2H7c-.566 0-1-.434-1-1V8c0-.566.434-1 1-1Zm9 4a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4Zm-4.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM16 16c-1.547 0-2.605.66-3.25 1.219A3.242 3.242 0 0 0 11.594 17C9.902 17 9 18 9 18v2h14v-2s-.918-1-2.406-1c-.512 0-.95.09-1.313.219A4.898 4.898 0 0 0 16 16Z",
    clipRule: "evenodd"
  })));
};
export default SvgClass;